import { Box, Card, Grid, Icon, IconButton, InputLabel } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDSelect from "components/MDSelect";
import MDTypography from "components/MDTypography";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { get, postNoResponse } from "utils/WebService";
import * as Yup from "yup";
import { errorAlert, successAlert } from "utils/Functions";

export default function CasosCreateEdit({ id, close }) {
    const [clientList, setClientList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [initialValues, setInitialValues] = useState({
        pessoa: null,
        nomeCaso: "",
        documento: "",
    });

    useEffect(() => {
        get("/pessoa/list-all").then(({ list }) => setClientList(list || [])).catch(() => {});
        if (id) {
            setIsLoading(true);
            get(`/processo/by-id-caso/${id}`).then(data => {
                setInitialValues({
                    pessoa: data.pessoa,
                    nomeCaso: data.nomeCaso,
                    documento: data.documento,
                });
            }).finally(() => setIsLoading(false));
        }
    }, [id]);

    const validationSchema = Yup.object().shape({
        pessoa: Yup.object().required("Selecione um cliente"),
        nomeCaso: Yup.string().required("Informe o nome do caso"),
        documento: Yup.string().required("Informe o documento"),
    });

    const handleSubmit = (values, actions) => {
        const payload = {
            id: id || null,
            pessoaId: values.pessoa?.id,
            nomeCaso: values.nomeCaso,
            documento: values.documento,
        };

        postNoResponse("/processo/save-caso", payload)
            .then(() => {
                successAlert("Caso salvo com sucesso!");
                close();
            })
            .catch((err) => {
                errorAlert(err?.response?.data?.message || err?.message || "Erro ao salvar o caso.");
            })
            .finally(() => actions.setSubmitting(false));
    };

    const handleDocumentoBlur = (doc, setFieldValue, currentNome) => {
        if (!doc) return;
        if (currentNome && currentNome.trim() !== "") return; // Only auto-fill if empty
        const cleanDoc = doc.replace(/\D/g, '');
        if (cleanDoc.length < 11) return;
        
        get(`/devedor/nome-by-documento/${cleanDoc}`)
            .then(res => {
                if (res && res.nome) {
                    setFieldValue("nomeCaso", res.nome);
                }
            })
            .catch(() => {}); // ignore errors quietly
    };

    return (
        <Card id="caso-info">
            <Box display="flex" alignItems="center" p={3}>
                <IconButton onClick={close} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                    <MDTypography variant="h5">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                <MDTypography variant="h6">{id ? "Editar Caso" : "Novo Cadastro de Caso"}</MDTypography>
            </Box>

            <Formik
                                enableReinitialize
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {({ values, errors, touched, setFieldValue, isSubmitting }) => {
                                    // Use setFieldValue in inside the block if needed or let formik handle it
                                    return (
                                    <Form autoComplete="off">
                                        <MDBox px={3}>
                                            <Grid container spacing={3}>
                                            <Grid item xs={12} md={4}>
                                                <InputLabel sx={{ px: 1, pb: 0.5 }}>CPF/CNPJ</InputLabel>
                                                <MDInput
                                                    fullWidth
                                                    size="small"
                                                    value={values.documento}
                                                    onChange={e => setFieldValue("documento", e.target.value)}
                                                    onBlur={() => handleDocumentoBlur(values.documento, setFieldValue, values.nomeCaso)}
                                                    error={errors.documento && touched.documento}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={8}>
                                                <InputLabel sx={{ px: 1, pb: 0.5 }}>Nome</InputLabel>
                                                <MDInput
                                                    fullWidth
                                                    size="small"
                                                    value={values.nomeCaso}
                                                    onChange={e => setFieldValue("nomeCaso", e.target.value)}
                                                    error={errors.nomeCaso && touched.nomeCaso}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <InputLabel sx={{ px: 1, pb: 0.5 }}>Cliente</InputLabel>
                                                <MDSelect
                                                    options={clientList}
                                                    getOptionLabel={o => o.nomeComum}
                                                    getOptionValue={o => o.id}
                                                    value={values.pessoa}
                                                    onChange={v => setFieldValue("pessoa", v)}
                                                    error={errors.pessoa && touched.pessoa}
                                                />
                                            </Grid>

                                            </Grid>
                                        </MDBox>
                                        <Box display="flex" alignItems="center" justifyContent="end" p={2}>
                                            <MDButton 
                                                type="submit" 
                                                variant="contained" 
                                                color="info" 
                                                disabled={isSubmitting}
                                            >
                                                {id ? "Salvar" : "Salvar Caso"}
                                            </MDButton>
                                        </Box>
                                    </Form>
                                    );
                                }}
                            </Formik>
        </Card>
    );
}
